import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtDate } from "@/lib/api";
import { usePaged, Pager, SearchBar } from "@/components/fo/Pager";
import { GiftDialog, OrderDialog, OrderRow } from "./Orders";

const Table = ({ head, children, testid }) => (
  <div className="panel overflow-x-auto" data-testid={testid}>
    <table className="w-full min-w-[640px] text-sm">
      <thead><tr className="border-b border-white/10 text-left font-mono text-[10px] uppercase tracking-widest text-slate-500">{head.map((h) => <th key={h} className="p-4 font-normal">{h}</th>)}</tr></thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);
const Td = ({ children, className = "" }) => <td className={`border-b border-white/5 p-4 ${className}`}>{children}</td>;

export const Orders = () => {
  const [list, setList] = useState([]);
  const [briefs, setBriefs] = useState({});
  const [cur, setCur] = useState(null);
  const load = () => api.get("/admin/orders").then((r) => setList(r.data));
  useEffect(() => { load(); api.get("/admin/briefs").then((r) => setBriefs(r.data)); }, []);
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-slate-400">Click an order to see the artist's brief, photos and links. Reviews and interviews can be written with AI from the brief.</p>
        <GiftDialog onDone={load} />
      </div>
      <Table head={["Date", "Artist", "Service", "Track", "Price", "Status", ""]} testid="admin-orders">
        {list.map((o) => <OrderRow key={o.id} o={o} open={setCur} Td={Td} />)}
      </Table>
      {!list.length && <p className="text-sm text-slate-500" data-testid="orders-empty">No orders yet.</p>}
      <OrderDialog o={cur} brief={cur && briefs[cur.service]} onClose={() => setCur(null)} onChange={load} />
    </div>
  );
};

export const Subscribers = () => {
  const [d, setD] = useState({ subscribers: [], payments: [] });
  const [q, setQ] = useState("");
  const subs = usePaged(d.subscribers, { query: q, fields: ["stage_name", "email", "plan"] });
  const pays = usePaged(d.payments, { query: q, fields: ["artist_name", "label", "provider"] });
  useEffect(() => { api.get("/admin/subscribers").then((r) => setD(r.data)); }, []);
  return (
    <div className="space-y-8">
      <SearchBar value={q} set={setQ} placeholder="Search artist, email, plan…" id="subscribers" />
      <div>
      <Table head={["Artist", "Plan", "Until", "Source", "Auto-renew"]} testid="admin-subscribers-table">
        {subs.rows.map((s) => (
          <tr key={s.id}><Td><div className="font-bold">{s.stage_name}</div><div className="text-xs text-slate-500">{s.email}</div></Td><Td className="uppercase text-[#00F5D4]">{s.plan}</Td>
            <Td className="font-mono text-xs">{fmtDate(s.until)}</Td><Td className="text-xs">{s.paying ? "Paid" : s.founding ? "Founding gift" : "Prize"}</Td><Td>{s.auto_renew ? "Yes" : "No"}</Td></tr>
        ))}
      </Table>
      <Pager {...subs} id="subscribers" />
      </div>
      <div>
      <div className="label-mono mb-3">Payments</div>
      <Table head={["Date", "Artist", "Item", "Amount", "Provider"]} testid="admin-payments-table">
        {pays.rows.map((p) => (
          <tr key={p.id}><Td className="font-mono text-xs">{fmtDate(p.paid_at)}</Td><Td>{p.artist_name}</Td><Td>{p.label}</Td><Td className="led">€{p.amount}</Td><Td className="font-mono text-xs uppercase text-[#FFB800]">{p.provider === "mock" ? "Simulated" : p.provider}</Td></tr>
        ))}
      </Table>
      <Pager {...pays} id="payments" />
      </div>
    </div>
  );
};

export const FlamesAdmin = () => {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/flames").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const voidAll = async (device_id) => { const { data } = await api.post("/admin/flames/void", { device_id }); toast.success(`${data.voided} Flames voided`); load(); };
  return (
    <div>
      <p className="mb-4 text-sm text-slate-400">Devices by Flames given in the last 24h. Flagged: 20+ Flames, or 8+ Flames all to the same artist. Each device is limited to 40 Flames per day.</p>
      <Table head={["Device", "Flames 24h", "Artists flamed", "", ""]} testid="admin-flames-table">
        {list.map((d) => (
          <tr key={d.device_id} data-testid={`flame-device-${d.device_id}`}>
            <Td className="font-mono text-xs">{d.device_id.slice(0, 18)}</Td><Td className="led">{d.count}</Td><Td className="text-xs text-slate-400">{d.artists.join(", ")}</Td>
            <Td>{d.suspicious && <span className="font-mono text-[10px] uppercase text-[#FF2E63]">Suspicious</span>}</Td>
            <Td><button className="btn-ghost !px-3 !py-1.5 text-xs" onClick={() => voidAll(d.device_id)} data-testid={`void-flames-${d.device_id}`}>Void Flames</button></Td>
          </tr>
        ))}
      </Table>
    </div>
  );
};
